/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsPreview
 */
export interface MelcoModelsPreview {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPreview
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPreview
     */
    url?: string | null;
}

export function MelcoModelsPreviewFromJSON(json: any): MelcoModelsPreview {
    return MelcoModelsPreviewFromJSONTyped(json, false);
}

export function MelcoModelsPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function MelcoModelsPreviewToJSON(value?: MelcoModelsPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}


